export default "__VITE_ASSET__CxcZi$CL__"